// extracted by mini-css-extract-plugin
export default {"products":"Zz-z","card":"_z-z","oosMessaging":"aA-z"};